import { EventsService, FetchingError } from '@/services/events.service'
import router from '@/router';

const state = {
    fetching: true,
    events: {},
    event: {},
    user_roles: [],
    fetchingErrorCode: 0,
    fetchingError: '',
}

const getters = {
    
    fetchingErrorCode: (state) => {
        return state.fetchingErrorCode
    },

    fetchingError: (state) => {
        return state.fetchingError
    },

    fetching: (state) => {
        return state.fetching
    },

    events: (state) => {
        // return typeof state.events !== 'undefined' && state.events.length > 0 ? state.events : false
        return state.events;
    },

    user_roles: (state) => {
        return state.user_roles;
    },

    event: (state) => {
        return state.event;
    },
}

const actions = {
    async fetchEvents({commit}, options) {
        
        commit('fetchEventsRequest');

        try {
            const events = await EventsService.fetchEvents(options);
            commit('fetchingEventsSuccess', events)

            // router.push(router.history.current.query.redirect || '/');

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },
    async fetchUserRoles({commit}) {
        
        commit('fetchUserRolesRequest');

        try {
            const user_roles = await EventsService.fetchUserRoles();
            commit('fetchingUserRolesSuccess', user_roles)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },
    async fetchEvent({commit}, event_id) {
        commit('fetchEventRequest');

        try {
            const event = await EventsService.fetchEvent(event_id);
            commit('fetchingEventSuccess', event)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },

    async saveApplication({commit}, {event_id, application_data}) {
        commit('saveApplicationRequest');

        try {
            const event = await EventsService.saveApplication(event_id, application_data);
            commit('saveApplicationSuccess', event)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },

    async saveEvent({commit}, {event_data}) {
        commit('saveEventRequest');

        try {
            const event = await EventsService.saveEvent(event_data);
            commit('saveEventSuccess', event)

            router.push('/event-list');

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },

    async deleteEvent({commit}, {event_data}) {

        try {
            const event = await EventsService.deleteEvent(event_data);
            commit('deleteEventSuccess', event)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },

    async deleteAgenda({commit}, {event_data}) {

        try {
            const event = await EventsService.deleteAgenda(event_data);
            commit('deleteAgendaSuccess', event)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },

    async updateApplicationStatus({commit}, {event_id, status_data}) {
        commit('updateApplicationStatusRequest');

        try {
            const event = await EventsService.updateApplicationStatus(event_id, status_data);
            commit('updateApplicationStatusSuccess', event);

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
              commit("fetchingError", {
                errorCode: e.errorCode,
                errorMessage: e.message
              });
            }

            return false
        }
    }

    // logout({ commit }) {
    //     EventsService.logout()
    //     commit('logoutSuccess')
    //     router.push('/login')
    // }
}

const mutations = {
    fetchEventsRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    fetchUserRolesRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    saveApplicationRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    saveEventRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    updateApplicationStatusRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    fetchEventRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    fetchingEventsSuccess(state, events) {
        state.events = events;
        state.fetching = false;
    },

    fetchingUserRolesSuccess(state, user_roles) {
        state.user_roles = user_roles;
        state.fetching = false;
    },

    saveApplicationSuccess(state, event) {
        state.event = event;
        state.fetching = false;
        // console.log('######', event);
        window.LC_Event.$emit('saveApplicationSuccess', event);
    },

    saveEventSuccess(state, event) {
        state.event = event;
        state.fetching = false;
    },

    deleteEventSuccess(state, event) {
        state.event = event;
        state.fetching = false;
        window.LC_Event.$emit('deleteEventSuccess', event);
    },

    deleteAgendaSuccess(state, event) {
        state.event = event;
        state.fetching = false;
        window.LC_Event.$emit('deleteAgendaSuccess', event);
    },

    updateApplicationStatusSuccess(state, event) {
        state.event = event;
        state.fetching = false;
        window.LC_Event.$emit('updateApplicationStatusSuccess', event);
    },
    
    fetchingEventSuccess(state, event) {
        // console.log(state);
        state.event = event;
        state.fetching = false;
        window.LC_Event.$emit('fetchingEventSuccess', event);
    },

    fetchingError(state, {errorCode, errorMessage}) {
        state.fetching = false
        state.fetchingErrorCode = errorCode
        state.fetchingError = errorMessage
    },

    // logoutSuccess(state) {
    //     state.accessToken = ''
    // }
}

// export const auth = {
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}